import {
  serviceUsersColumns,
  serviceUsersDefaultColumns,
  serviceUsersSorts,
  serviceUsersSpecificFilters,
} from '@cabgo/shared';
import type { ReportViewDefinition } from '../reportViewTypes';

export const serviceUsersView: ReportViewDefinition = {
  key: 'service_users',
  titleKey: 'suTitle',
  descriptionKey: 'suDescription',
  dateBasisKey: 'suDateBasis',
  columns: serviceUsersColumns,
  defaultColumns: serviceUsersDefaultColumns,
  dateMode: 'allTime',
  supportsSearch: true,
  defaultSort: 'registeredAt',
  sorts: serviceUsersSorts,
  filters: serviceUsersSpecificFilters.map((definition) => ({
    ...definition,
    labelKey: `suFilter_${definition.id}`,
    ...(definition.id === 'passengerStatuses'
      ? { options: definition.values.map((value) => ({ value, labelKey: `suStatus_${value}` })) }
      : {}),
  })),
  valueLabels: {
    passenger_status: {
      ACTIVE: 'suStatus_ACTIVE',
      INACTIVE: 'suStatus_INACTIVE',
      SUSPENDED: 'suStatus_SUSPENDED',
    },
    date_basis: { PASSENGER_CREATED_AT: 'suDateBasis' },
    group_evidence_basis: { CURRENT_MEMBERSHIP_AND_ELIGIBILITY: 'suCurrentMembership' },
    group_visibility: { PROVIDER_LOCAL: 'suProviderLocal' },
    area_evidence_basis: { CURRENT_SERVICE_GROUP: 'suCurrentServiceGroup' },
    service_history_basis: { COMPLETED_TRIP_SERVICE_DATE: 'suCompletedServiceDate' },
  },
  summary: [
    { field: 'providerPassengerRowCount', labelKey: 'suSummaryRows', unit: 'count' },
    { field: 'distinctPassengerCount', labelKey: 'suSummaryPeople', unit: 'count' },
    { field: 'bookingCount', labelKey: 'suSummaryBookings', unit: 'count' },
    { field: 'tripCount', labelKey: 'suSummaryTrips', unit: 'count' },
    { field: 'completedTripCount', labelKey: 'suSummaryCompleted', unit: 'count' },
    { field: 'withCompletedServiceCount', labelKey: 'suSummaryWithCompleted', unit: 'count' },
  ],
  primarySummary: [
    'distinctPassengerCount',
    'providerPassengerRowCount',
    'bookingCount',
    'tripCount',
    'completedTripCount',
    'withCompletedServiceCount',
  ],
  summaryGroups: [
    {
      labelKey: 'summaryGroupOverview',
      fields: [
        'providerPassengerRowCount',
        'distinctPassengerCount',
        'bookingCount',
        'tripCount',
        'completedTripCount',
        'withCompletedServiceCount',
      ],
    },
  ],
};
